import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, ButtonGroup, Button, useTheme } from '@mui/material';
import '../../../../static/styles/tripleswitch.css';

const valueType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
]);

const TripleToggleSwitch = ({
  labels={
    left: { title: 'Off', value: 'Off' },
    center: { title: 'HR', value: 'HR' },
    right: { title: 'VHR', value: 'VHR' },
  }, onChange, styles }) => {
  const [switchPosition, setSwitchPosition] = useState('left');
  const [animation, setAnimation] = useState(null);
  const theme = useTheme();

  const getSwitchAnimation = (value) => {
    const animationMap = {
      'left-center': 'left-to-center',
      'center-right': 'center-to-right',
      'right-center': 'right-to-center',
      'center-left': 'center-to-left',
      'left-right': 'left-to-right',
      'right-left': 'right-to-left',
    };

    const key = `${switchPosition}-${value}`;
    const newAnimation = animationMap[key] || null;

    setSwitchPosition(value);
    setAnimation(newAnimation);
    onChange(value);
  };

  const buttonProps = (position) => ({
    onClick: () => getSwitchAnimation(position),
    sx: {
      borderRight: 'none !important',
      borderRadius: '10px',
      marginLeft: position === 'left' ? '2px' : position === 'center' ? '0px' : '-4px',
      marginTop: '1px',
    },
  });

  TripleToggleSwitch.propTypes = {
    labels: PropTypes.shape({
      left: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: valueType,
      }).isRequired,
      center: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: valueType,
      }).isRequired,
      right: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: valueType,
      }).isRequired,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    styles: PropTypes.object,
  };

    return (
    <Box className="main-container" sx={styles}>
      <Box
        className={`switch ${animation} ${switchPosition}-position`}
      />
      <ButtonGroup variant="text" size="small" sx={{ height: '100%' }}>
        {['left', 'center', 'right'].map((position) => (
          <Button key={position} {...buttonProps(position)}>
            <Typography
              component="h4"
              sx={{
                color: switchPosition === position ? 
                theme.palette.primary.main : theme.palette.primary.white,
              }}
            >
              {labels[position].title}
            </Typography>
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
  };

export default TripleToggleSwitch;
